
import Vue from 'vue'

import { debounce } from '~/plugins/helper'

import HeaderLogo from './Logo.vue'
import HeaderNavigation from './Navigation.vue'
import HeaderText from './Text.vue'

export default Vue.extend({
  name: 'GlobalHeader',
  components: {
    HeaderLogo,
    HeaderNavigation,
    HeaderText
  },
  data(): {
    isScrolled: boolean
    onScroll: ReturnType<typeof debounce> | null
    blendmodeTimer: ReturnType<typeof setTimeout> | null
    } {
    return {
      isScrolled: false,
      onScroll: null,
      blendmodeTimer: null
    }
  },
  computed: {
    isShowMenu(): boolean {
      // @ts-ignore
      return (this.$store.state as StoreState).isShowMenu
    }
  },
  watch: {
    isShowMenu: {
      handler(newVal: boolean) {
        // Avoid SSR issues
        if (!process.client) {
          return
        }

        if (newVal) {
          if (this.blendmodeTimer) {
            clearTimeout(this.blendmodeTimer)
            this.blendmodeTimer = null
          }
          window.setTimeout(() => {
            this.$el?.classList.add('hide-blendmode')
          }, 0)
        } else {
          if (this.blendmodeTimer) {
            clearTimeout(this.blendmodeTimer)
            this.blendmodeTimer = null
          }
          // Delay removing class by 500ms when menu closes
          this.blendmodeTimer = setTimeout(() => {
            this.$el?.classList.remove('hide-blendmode')
            this.blendmodeTimer = null
          }, 500)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.onScroll = debounce(this.handleScroll, 10)
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    // @ts-ignore
    window.removeEventListener('scroll', this.onScroll)
    // Clear pending timer if any
    if (this.blendmodeTimer) {
      // @ts-ignore
      clearTimeout(this.blendmodeTimer)
      this.blendmodeTimer = null
    }
  },
  methods: {
    handleScroll(): void {
      const scrollTop = window.scrollY
      if (scrollTop > 0 && window.innerWidth >= 1280) {
        this.isScrolled = true
      } else {
        this.isScrolled = false
      }
    }
  }
})
